import { useMutation } from '@apollo/client'
import { useCallback } from 'react'
import { useHistory } from 'react-router'

import { Button, Card } from '../../components'
import { Paths } from '../../config/routes'
import { useUser } from '../../contexts/user/user-context'
import { Notify } from '../../lib/helpers'
import { UpdateRole } from './queries'

export function DemoSettings() {
    const [updateRole] = useMutation(UpdateRole)
    const { getUser } = useUser()
    const history = useHistory()
    const handleRole = useCallback(
        async role => {
            await updateRole({ variables: { input: { role: role } } })
            Notify(
                'success',
                'Yippee!',
                `You are a ${role.split('_').join(' ').toLowerCase()}`,
            )

            await getUser()
            switch (role) {
                case 'INDIVIDUAL':
                    history.push(Paths.DASHBOARD)
                    break
                case 'BUSINESS':
                    history.push(Paths.DASHBOARD)
                    break
                case 'LIQUIDITY_PROVIDER':
                    history.push(Paths.DASHBOARD_INVESTOR)
                    break
                case 'VALIDATOR':
                    history.push(Paths.DASHBOARD_VALIDATOR)
                    break
                default:
                    history.push(Paths.DASHBOARD)
            }
        },
        [history, updateRole, getUser],
    )

    return (
        <div>
            <Card className='p-12'>
                <h2>Demo Settings</h2>

                <div className='flex flex-row gap-x-4'>
                    <Button onClick={() => handleRole('INDIVIDUAL')}>
                        Become a Borrower
                    </Button>
                    <Button onClick={() => handleRole('LIQUIDITY_PROVIDER')}>
                        Become a Liquidity Provider
                    </Button>
                    <Button onClick={() => handleRole('VALIDATOR')}>
                        Become a Validator
                    </Button>
                </div>
            </Card>
        </div>
    )
}
